module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/nZKgur/tc-custom/9781504082686.jpg?1705202203859",
      "alt": "This image is the cover for the book Treasury of Law"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Treasury of Law\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("This anthology of historic legal documents ranges from the ancient Code of Hammurabi to the American Civil Rights Act.")])]), _c('p', [_vm._v(" In this volume, Richard W. Nice has assembled a wealth of meaningful and significant documents that represent humanity’s ever-evolving attempt to govern society by imposing laws. Drawn from ancient, medieval, and modern times, this anthology provides an enlightening overview of world history and legal theory, told entirely in primary documents. ")]), _vm._v(" Some of the earliest attempts to regulate human behavior sprang from powerful, primitive religious influences that governed matters of ethics and morals, such as the Mosaic Code of Palestine. The first “pure” law can be traced back to the Law of the Twelve Tables, the forerunner of Roman Law, which in turn had an immeasurable effect on modern Western law. Organized by region and era, "), _c('i', [_vm._v("Treasury of Law")]), _vm._v(" is an essential volume for anyone curious about the evolution of legal codes and practices.\n    "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Richard W. Nice\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Philosophical Library/Open Road Media\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0